import { render, staticRenderFns } from "./TripsList.vue?vue&type=template&id=dcb91672&scoped=true"
import script from "./TripsList.vue?vue&type=script&lang=js"
export * from "./TripsList.vue?vue&type=script&lang=js"
import style0 from "./TripsList.vue?vue&type=style&index=0&id=dcb91672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb91672",
  null
  
)

export default component.exports